import { useEffect, useState } from 'react';

// Adresse als Zustand: /<modul>/<ansicht>[/<weiteres>][?firma=…]; Vor und Zurück des Browsers funktionieren

const EREIGNIS = 'neuratek:ort';
const jetzt = () => location.pathname + location.search;

// Zurück stellt auch die Scrollhöhe wieder her (Leon 2026-10-28): sie steht im Verlaufseintrag, die Seite lädt ihre Daten erst danach
history.scrollRestoration = 'manual';
window.addEventListener('popstate', () => {
  const y = (history.state as { y?: number } | null)?.y ?? 0;
  let n = 0;
  const f = () => { scrollTo(0, y); if (Math.abs(scrollY - y) > 1 && n++ < 60) setTimeout(f, 50); };
  setTimeout(f, 0);
});

export function gehe(pfad: string, ersetzen = false) {
  if (pfad === jetzt()) return;
  if (ersetzen) history.replaceState(history.state, '', pfad);
  else {
    history.replaceState({ ...(history.state as object | null), y: scrollY }, '');
    history.pushState({ app: true }, '', pfad);
  }
  window.dispatchEvent(new Event(EREIGNIS));
}

/** Zurück dorthin, wo man herkam (gleiche Ansicht, Filter, Scrollhöhe); kam man von außen, zur angegebenen Seite. */
export function zurueckNach(pfad: string) {
  if ((history.state as { app?: boolean } | null)?.app) history.back();
  else gehe(pfad);
}

/** Teile des Pfads; rendert auch neu, wenn sich nur die Abfrage (?…) ändert. */
export function useOrt(): string[] {
  const [adresse, setAdresse] = useState(jetzt);
  useEffect(() => {
    const neu = () => setAdresse(jetzt());
    window.addEventListener('popstate', neu);
    window.addEventListener(EREIGNIS, neu);
    return () => { window.removeEventListener('popstate', neu); window.removeEventListener(EREIGNIS, neu); };
  }, []);
  return adresse.split('?')[0].split('/').filter(Boolean).map(decodeURIComponent);
}

export const suchwert = (name: string) => new URLSearchParams(location.search).get(name);

/** Wert in der Adresse (?name=…) als Zustand, z. B. Tafel oder Tabelle; so führt Zurück in dieselbe Ansicht. Der Standard steht nicht in der Adresse. */
export function useAdresswert<T extends string>(name: string, standard: T, erlaubt?: readonly T[]): [T, (w: T) => void] {
  useOrt();
  const roh = suchwert(name) as T | null;
  const wert = roh !== null && (!erlaubt || erlaubt.includes(roh)) ? roh : standard;
  const setzen = (w: T) => {
    const q = new URLSearchParams(location.search);
    if (w === standard) q.delete(name); else q.set(name, w);
    const s = q.toString();
    gehe(location.pathname + (s ? `?${s}` : ''), true);
  };
  return [wert, setzen];
}
